// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3yOCU","bigColWidth":"Table_bigColWidth__LVs2Z","biggerColWidth":"Table_biggerColWidth__2xEbm","row":"Table_row__2IX_J","col":"Table_col__3CF-Y"};